import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { active_img, deactive_img, delete_icon, edit_icon, eye_icon, left_arrow, password_icon, toggle_off, toggle_on, user_profile, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { admin_list, property_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import { useLazyMinimumAgeQuery, useLazyMinimumAgeViewQuery, useMinimumAgeAddMutation, useMinimumAgeEditMutation, useMinimumAgeMutation, useMinimumAgeStatusMutation } from '../redux/api/api';
import { toast } from 'react-toastify';

const MinimumAge = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [popup, setPopup] = useState(false);
  const [list, setList] = useState([]);
  const [type, setType] = useState();
  const [id, setId] = useState();
  const [age, setAge] = useState();
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [loader, setLoader] = useState(false);


  const [minimumAgeApi] = useMinimumAgeMutation();
  const [minimumAgeViewApi] = useLazyMinimumAgeViewQuery();
  const [minimumAgeEditApi] = useMinimumAgeEditMutation();
  const [minimumAgeAddApi] = useMinimumAgeAddMutation();
  const [minimumAgeStatusApi] = useMinimumAgeStatusMutation();

  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))


  const minimumAge = (page) => {
    const formdata = new FormData();
    formdata.append("type", 2)
    formdata.append("page", page)
    formdata.append("row", 10)

    minimumAgeApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = []
        res?.categories?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        setPagecount(res?.pagination)
      })
      .catch((err) => {
        console.log("err", err);
      })
  }
  const minimumAgeView = (id) => {
    minimumAgeViewApi(id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.category) {
          setPopup(true);
          setType("edit");
          setId(id)
          setAge(res?.category?.name);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  const minimumAgeEdit = () => {
    if (!age) {
      toast.error("Enter Age");
      return;
    }
    const formdata = new FormData();
    formdata.append("type", 2)
    formdata.append("id", id)
    formdata.append("name", age)
    setLoader(true);
    minimumAgeEditApi({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          setPopup(false);
          toast.success(res?.message);
          minimumAge();
          setAge("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  }
  const minimumAgeAdd = () => {
    if (!age) {
      toast.error("Enter Age");
      return;
    }
    const formdata = new FormData();
    formdata.append("type", 2)
    formdata.append("name", age)
    setLoader(true);
    minimumAgeAddApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          setPopup(false);
          toast.success(res?.message);
          minimumAge()
          setAge();
        }
      })
      .catch((err) => {
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  }
  const minimumAgeStatus = (id) => {
    const formdata = new FormData();
    formdata.append("id", id);
    minimumAgeStatusApi(id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          minimumAge()
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    minimumAge(pageno);
  }, [pageno]);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Age",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <select disabled={rolePermissions?.includes('CAN-STATUS-MASTER') ? false : true}
                value={value}
                onChange={() => { minimumAgeStatus(row.original.id) }}
                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1 ? "active-btn" : "suspend-btn"
                  }`}
              >
                <option
                  className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1}
                >
                  Active
                </option>
                <option
                  className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={0}
                >
                  Deactive
                </option>
              </select>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                  <button
                    onClick={() => { minimumAgeView(row.original.id) }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                  </button>}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );


  return (
    <div className="dashRightView home_section" >
      <div className='d-flex ac-jb'>
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Masters - Minimum Age
        </h2>
        {rolePermissions?.includes('CAN-ADD-MASTER') &&
          <button onClick={() => { setPopup(true); setType("add") }} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add </button>}
      </div>
      <div>
        <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className='d-flex ac-jb'
              onClick={() => { setPopup(false); setAge("") }}
            >
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                {type == "add" ? "Add" : "Edit"}
              </h2>
              <CancelIcon />
            </div>
            <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Age
            </h4>
            <input type="text" value={age} onChange={(e) => { setAge(e.target.value) }} className="input-pop ps-2 w-100" placeholder="Age" />

            <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <button onClick={() => { { type == "edit" ? minimumAgeEdit(popup) : minimumAgeAdd() } }} className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                {loader && (
                  <div
                    class="spinner-border spinner-border-sm "
                    role="status"
                    style={{ marginRight: "5px" }}
                  ></div>
                )}
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}


export default MinimumAge